import { render, staticRenderFns } from "./PolygonEx.vue?vue&type=template&id=58ce3c46&"
import script from "./PolygonEx.vue?vue&type=script&lang=js&"
export * from "./PolygonEx.vue?vue&type=script&lang=js&"
import style0 from "./PolygonEx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports